var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
export var switchInputIdentifier = 'citrus-switch-input-m725t';
export var switchLabelIdentifier = 'citrus-switch-label-c0d3d';
var isHexColor = function (value) { return /^#[0-9a-f]{6}$/i.test(value); };
var getCheckmark = function (color) {
    var svgSafeColor = color.replace('#', '%23');
    return "url(\"data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ctitle%3Ebold/checkmark-bold%3C/title%3E%3Cpath fill='".concat(svgSafeColor, "' id='Combined-Shape' class='st0' d='M66.7 107l60.5-86.4c.6-.9.4-2.1-.5-2.8l-9.8-6.9c-.9-.6-2.1-.4-2.8.5L54.5 96.6l-44.2-31c-.9-.6-2.2-.4-2.8.5L.6 75.9c-.6.9-.4 2.1.5 2.8l45.4 31.8c.1.1.2.3.4.4l9.8 6.9c.5.4 1.2.5 1.8.3.4-.1.8-.4 1.1-.8l6.9-9.8c.1-.2.2-.4.2-.5z'/%3E%3C/svg%3E\")");
};
var disabled = (_a = {},
    _a["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#DFE4E8',
        borderColor: '#A8B2BA',
        cursor: 'not-allowed',
        // knob
        ':before': {
            backgroundColor: '#8E9AA3',
        },
    },
    _a[':hover'] = (_b = {},
        _b["& + .".concat(switchLabelIdentifier)] = {
            backgroundColor: '#DFE4E8',
            // knob
            ':before': {
                backgroundColor: '#A8B2BA',
            },
        },
        _b),
    _a);
var hover = (_c = {},
    _c["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#E5EFFF',
        // knob
        ':before': {
            backgroundColor: '#2B66D6',
        },
    },
    _c);
var focus = (_d = {},
    _d["& + .".concat(switchLabelIdentifier)] = {
        outline: "2px solid ".concat('#2B66D6'),
        outlineOffset: '2px',
    },
    _d);
var checked = (_e = {},
    _e["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#1454CC',
        borderColor: '#1454CC',
        // knob
        ':before': {
            backgroundColor: '#ffffff',
            backgroundImage: isHexColor('#002E85') ? getCheckmark('#002E85') : getCheckmark(''),
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 12,
            left: 24 - 4,
        },
    },
    _e[':disabled'] = __assign(__assign({}, disabled), (_f = {}, _f["& + .".concat(switchLabelIdentifier)] = __assign(__assign({}, disabled["& + .".concat(switchLabelIdentifier)]), { ':before': {
            backgroundImage: isHexColor('#8E9AA3') ? getCheckmark('#8E9AA3') : getCheckmark(''),
            backgroundColor: '#A8B2BA',
        } }), _f)),
    _e[':hover'] = (_g = {},
        _g["& + .".concat(switchLabelIdentifier)] = {
            backgroundColor: '#1454CC',
            ':before': {
                backgroundColor: '#E5EFFF',
            },
        },
        _g),
    _e);
export var switchBase = (_h = {
        // turn off default element
        appearance: 'none',
        height: 0,
        width: 0
    },
    // switch base styles
    _h["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#ffffff',
        border: "1px solid ".concat('#7E8A94'),
        borderRadius: 999,
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'inline-block',
        height: 32,
        position: 'relative',
        width: 48,
        // knob, and also somehow the label
        ':before': {
            color: '#ffffff',
            fontSize: 16,
            fontWeight: 500,
            left: 4,
            lineHeight: '150%',
            margin: 0,
            padding: 0,
            position: 'absolute',
            textAlign: 'center',
            top: 3,
            transition: 'left 0.15s ease-out',
            zIndex: 1,
            backgroundColor: '#1454CC',
            borderRadius: '50%',
            content: '" "',
            height: 24,
            width: 24,
        },
        ':after': {
            display: 'none',
        },
    },
    _h[':disabled'] = disabled,
    _h[':hover'] = hover,
    _h[':focus'] = focus,
    // leave checked last, probably
    _h[':checked'] = checked,
    _h);
export var combinators = (_j = {},
    _j[".".concat(switchInputIdentifier, " + .").concat(switchInputIdentifier)] = {
        padding: "".concat(8, "px 0 0 0"),
    },
    _j);
export var errorSwitch = __assign(__assign({}, switchBase), (_k = { ':checked': __assign(__assign({}, switchBase[':checked']), (_l = {}, _l["& + .".concat(switchLabelIdentifier)] = __assign(__assign({}, switchBase[':checked']["& + .".concat(switchLabelIdentifier)]), { outline: "2px solid ".concat('#CC0821'), outlineOffset: '2px' }), _l)) }, _k["& + .".concat(switchLabelIdentifier)] = __assign(__assign({}, switchBase["& + .".concat(switchLabelIdentifier)]), { outline: "2px solid ".concat('#CC0821'), outlineOffset: '2px' }), _k));
export var switchWrapper = {
    display: 'flex',
    height: '100%',
};
